// extracted by mini-css-extract-plugin
module.exports = {"container":"BlockColumnsAndIcons_container__tFwUC","itemContainer":"BlockColumnsAndIcons_itemContainer__DgLd6"};